import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import useWindowDimensions from 'customHook/useWindowDimensions';
import moment from 'moment-timezone';
import { TIME_ZONE } from 'constants/constant';

const useTimeline = (validRooms, validBookings) => {

  const { width } = useWindowDimensions();
  const [items, setItems] = useState([]);
  const [groups, setGroups] = useState({});

  const pickedDate = useSelector(state => state.pickedDateReducer.pickedDate)
  const [state, setState] = useState({
    visibleTimeStart: moment(pickedDate)
      .tz(TIME_ZONE)
      .startOf('week')
      .valueOf(),
    visibleTimeEnd: moment(pickedDate)
      .tz(TIME_ZONE)      
      .startOf('week')
      .add(Math.floor(width/120), 'day')
      .valueOf(),
    today: moment(pickedDate).tz(TIME_ZONE).startOf('day').valueOf(),
    endToday: moment(pickedDate).tz(TIME_ZONE).endOf('day').valueOf(),
  });

  useEffect(() => {
    const visibleTimeStart = moment(pickedDate)
      .tz(TIME_ZONE)
      .startOf('week')
      .valueOf();
    const visibleTimeEnd = moment(pickedDate)
      .tz(TIME_ZONE)
      .startOf('week')
      .add(Math.floor(width/120), 'day')
      .valueOf();
    const today = moment(pickedDate).tz(TIME_ZONE).startOf('day').valueOf();
    const endToday = moment(pickedDate).tz(TIME_ZONE).endOf('day').valueOf();
    setState({
      visibleTimeStart,
      visibleTimeEnd,
      today,
      endToday,
    });
  }
  ,[pickedDate, width]);

  useEffect(() => {
    const newItems = [];
    let newGroups = {};

    if (validBookings) {
      validBookings.forEach((booking, index) => {
        newItems.push({
          id: booking.bookingId + '/' + booking.group?.groupId,
          group: booking.roomBookings?.[0]?.room?.roomNumber,
          title: booking.status+
            '/' +(booking.group?.name.length > 0? booking.group.name: booking.fullName)
            +'/'+ booking.group?.groupId,
          start: moment(booking.checkedInAt || booking.checkInDate).tz(TIME_ZONE).valueOf(),
          end: moment(booking.checkedOutAt || booking.checkOutDate).tz(TIME_ZONE).valueOf(),
          canMove: true,
          canResize: false,
          canChangeGroup: true,
        });
      });
    }

    if (validRooms) {
      const sortedRooms = [...validRooms].sort((a,b) => Number(a.roomNumber)-Number(b.roomNumber))
      sortedRooms.forEach((room, index) => {
        if(room.roomType.name === 'Amenities') {
          return
        }
        newGroups[room.roomType.name] = newGroups[room.roomType.name] || []
        newGroups[room.roomType.name].push({
          id: room.roomNumber,
          roomId: room.roomId,
          roomTypeName: room.roomType.name,
          status: room.roomStatusHistories?.[0]?.status,
          height: 32
        })
      })
    }
    setGroups(newGroups)
    setItems(newItems)
  },[validBookings, validRooms])



  useEffect(() => {
    //disable timeline horizontal scroll
    if (document.querySelector('.rct-scroll')) {
      document.querySelector('.rct-scroll').style.overflowX = 'hidden';
    }
  },[]);

  return {
    timelineState: {
      state,
      setState,
    },
    groups,
    items,
    setGroups,
    setItems
  };
};

export default useTimeline;
